module.exports = __webpack_public_path__ + "static/commoners-d58a25f495a490590dc59c13cbd3adf1.png";